import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GITBRANCH, GITCOMMITHASH, VERSION } from 'app/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { AuthServerProvider } from 'app/core';
import { UserService } from '../../services/user.service';
import { CookieService } from 'ngx-cookie';
import { check } from 'prettier';

@Component({
    selector: 'jhi-custom-box',
    templateUrl: './custom-box.component.html',
    styleUrls: ['../../../../../content/scss/styles.scss']
})
export class CustomBoxComponent implements OnInit {
    @Input() title = '';
    @Input() subTitle: string;
    @Input() footerText: string;
    @Input() requiredFields = false;
    @Input() translateParams: any;
    @Input() boxSize = 'box-400';
    @Input() successMsg: string;
    @Input() errorMsg: string;
    @Input() yellowSubTitle = false;
    @Input() successButtonLabel = 'buttons.ok';
    @Input() failureButtonLabel = 'buttons.ok';
    @Input() contentLoading: boolean;

    @Output() successEmitter = new EventEmitter();
    @Output() failureEmitter = new EventEmitter();

    version: string;
    organization: string;
    isUserLogged: boolean = false;
    showPasswordRules = false;

    constructor(
        private router: Router,
        private translateService: TranslateService,
        private authServerProvider: AuthServerProvider,
        private userService: UserService,
        private jwtService: AuthServerProvider,
        private cookieService: CookieService
    ) {
        this.version = VERSION + '-' + GITBRANCH + '-' + GITCOMMITHASH.substr(0, 6);

        const language = this.translateService.getBrowserLang();
        translateService.use(language);
    }

    ngOnInit() {
        if (this.jwtService.getToken()) {
            this.isUserLogged = true;
        }
        this.jwtService
                    .organization()
                    .toPromise()
                    .then(res => {
                        this.organization = res.body
                    });
    }


    success() {
        this.successMsg = '';
        this.successEmitter.emit();
        // this.router.navigate(['/']);
    }

    failure() {
        this.errorMsg = '';
        this.failureEmitter.emit();
        if (window.location.hash === '#/passwordDimenticata') {
            this.redirectTo('/passwordDimenticata');
        }
    }

    redirectTo(uri: string) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate([uri]));
    }

    redirect() {
        this.userService
            .logout()
            .toPromise()
            .then(res => {
                // remove jwt token client-side
                this.jwtService.logout();
                window.location.href = res.body;
            });
    }
}

